import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_34_and_35.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Head from "next/head";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter34.json";

export default function Chapter_34() {
  //   const corosalref = useRef()

  //   useEffect(()=>{
  //     if(corosalref.current)
  //     {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent",corosalref.current);
  // },[corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  return (
    <>
      <Head>
        <title>THE ART AND SCIENCE OF ASTROLOGY | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXXVI"
        ></meta>
        <meta
          property="og:title"
          content="THE ART AND SCIENCE OF ASTROLOGY | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An intricate depiction of celestial bodies and astrological charts, merging artistic and scientific elements. The image illustrates the intersection of astrology’s ancient symbols with modern analytical methods, highlighting the harmonious blend of mystical insight and empirical study."></meta>
        <meta
          property="og:description"
          content="Explore the Central Doctrine of The Art and Science of Astrology, where ancient wisdom meets modern understanding. Delve into how astrological principles influence human behavior and cosmic events, bridging the mystical and scientific aspects of this timeless discipline."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=34"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An intricate depiction of celestial bodies and astrological charts, merging artistic and scientific elements. The image illustrates the intersection of astrology’s ancient symbols with modern analytical methods, highlighting the harmonious blend of mystical insight and empirical study."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=34"></meta>
        <meta name="twitter:title" content="THE ART AND SCIENCE OF ASTROLOGY | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Explore the Central Doctrine of The Art and Science of Astrology, where ancient wisdom meets modern understanding. Delve into how astrological principles influence human behavior and cosmic events, bridging the mystical and scientific aspects of this timeless discipline."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=34" />
      </Head>

     
      <Common_html BlockData={BlockData} />

    </>
  );
}
